import { React, useEffect, useState, useMemo } from "react";
import { assignProjectComponents, getComponents,getComponentTypes,CreateComponents } from "../../services/Api";
import cogoToast from "cogo-toast";
import { SUCCESS_RESULT, ENDPOINTS, DEFAULT_RESULT } from "../../Constants";
import { Spinner } from "reactstrap";
import { useHistory, Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Table, Button, Badge } from "reactstrap";
import * as Survey from "survey-react";
import {   genericGet, genericPost } from "../../services/Api";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import makeAnimated from "react-select/animated";
import {
  
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Form,
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from 'reactstrap';
import { FaPlus, FaEdit, FaCalendarAlt, FaFileAlt, FaCheckCircle, FaTimesCircle, FaUsers, FaExchangeAlt, FaExclamationTriangle, FaSort, FaSortUp, FaSortDown, FaTrash } from 'react-icons/fa';
import ability from "../config/defineAbility";
import { PERMS } from "../config/perms";

import "survey-react/survey.css";

const formatTableDate = (value) => {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  } catch {
    return value;
  }
};

const isMobileUploadAllowed = (row) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const endDateRaw = row?.enrollment_enddate;
  const parsedEndDate = endDateRaw ? new Date(endDateRaw) : null;
  const isEndDatePassed =
    parsedEndDate instanceof Date &&
    !Number.isNaN(parsedEndDate.getTime()) &&
    parsedEndDate < today;
  return (
    !isEndDatePassed &&
    (row?.allow_mobile_beneficiary_upload === true ||
      row?.allow_mobile_beneficiary_upload === 10001 ||
      row?.allow_mobile_beneficiary_upload === "10001")
  );
};

const isCardRequired = (row) => row?.card_onboarding_required == 10001;

const parseAllowCrossComponentRegistration = (value) => {
  if (value === true || value === 10001 || value === "10001") return 10001;
  return 10002;
};

const ProjectComponents = (props) => {
  const history = useHistory();
  const animatedComponents = makeAnimated();
  const { project } = (props.location && props.location.state) || {};
  const [isLoading, setIsLoading] = useState(false);
  const [components, setComponents] = useState([]);
const [createModal, setcreateModal] = useState(false)
const [editModal, setEditModal] = useState(false)
const [extra_templates, setextra_templates] = useState([])
const [criteria_templates, setcriteria_templates] = useState([])
const [total_target, settotal_target] = useState(0);
 const [enrollment_template_id, setEnrollment_template_id] = useState("")
 const [criteria_template_id, setcriteria_template_id] = useState("")
  const [componentSearch, setComponentSearch] = useState("");
  const [sortField, setSortField] = useState("name");
  const [sortDirection, setSortDirection] = useState("asc");
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [componentToDelete, setComponentToDelete] = useState(null);
  const [isDeletingComponent, setIsDeletingComponent] = useState(false);

  // let template = {
  //   logoPosition: "right",
  //   pages: [
  //     {
  //       name: "page1",
  //       elements: [
  //         {
  //           type: "matrixdynamic",
  //           name: "q1",
  //           title: "Assign Components to this Project",
  //           isRequired: true,
  //           columns: [
  //             {
  //               name: "project_components_id",
  //               title: "Component",
  //               cellType: "dropdown",
  //               isRequired: true,
  //             },
  //             {
  //               name: "start_date",
  //               title: "Start Date",
  //               cellType: "text",
  //               isRequired: true,
  //               inputType: "date",
  //             },
  //             {
  //               name: "end_date",
  //               title: "End Date",
  //               cellType: "text",
  //               isRequired: true,
  //               inputType: "date",
  //             },
  //           ],
  //           choices: [
  //             {
  //               value: "2ba0df7e-184b-4c65-9ae2-47fc66b76164",
  //               text: "Unconditional cash transfer",
  //             },
  //             {
  //               value: "49bc726c-1837-47fd-af1d-7cc5192c6088",
  //               text: "Relief food",
  //             },
  //             {
  //               value: "daffbc3a-4162-43c1-b06e-eb9b3bf322f1",
  //               text: "Non-Food Items(NFI)",
  //             },
  //             {
  //               value: "83a7af11-2a3c-4272-9e5d-97cd5ffdd962",
  //               text: "Conditional cash transfer",
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  //   textUpdateMode: "onTyping",
  //   widthMode: "static",
  //   showCompletedPage: false,
  // };
  const [component_types, setcomponent_types] = useState([])
  const toggle = () => {
    setcreateModal(!createModal);
    // Reset create form state when closing
    if (createModal) {
      setCreateName('');
      setCreateComponentTypeId('');
      setCreateEnrollmentStartdate('');
      setCreateEnrollmentEnddate('');
      setCreateRegistrationBioRequired(10001);
      setCreateCardOnboardingRequired(10001);
      setCreateEnrollmentTemplateId('');
      setCreateCriteriaTemplateId('');
      setCreateTotalTarget(0);
    }
  };
  const Edittoggle = () => {
    setEditModal(!editModal);
    setActiveTab('edit');
    if (editModal) {
      setAllowCrossComponentRegistration(10002);
      setAllowCrossComponentRegistrationReason('');
    }
  };


// Edit form state
const [name, setname] = useState('')
const [component_id, setcomponent_id] = useState('')
const [component_type_id, setcomponent_type_id] = useState('')

const [enrollment_startdate, setenrollment_startdate] = useState(null)
const [enrollment_enddate, setenrollment_enddate] = useState(null)
const [registration_bio_required, setregistration_bio_required] = useState(null)
const [card_onboarding_required, setcard_onboarding_required] = useState(null)
const [status, setstatus] = useState(null)
const [allow_mobile_beneficiary_upload, setallow_mobile_beneficiary_upload] = useState(false)

const [extra_info_template_id, setextra_info_template_id] = useState(null)

// Create form state
const [createName, setCreateName] = useState('')
const [createComponentTypeId, setCreateComponentTypeId] = useState('')
const [createEnrollmentStartdate, setCreateEnrollmentStartdate] = useState('')
const [createEnrollmentEnddate, setCreateEnrollmentEnddate] = useState('')
const [createRegistrationBioRequired, setCreateRegistrationBioRequired] = useState(10001)
const [createCardOnboardingRequired, setCreateCardOnboardingRequired] = useState(10001)
const [createEnrollmentTemplateId, setCreateEnrollmentTemplateId] = useState('')
const [createCriteriaTemplateId, setCreateCriteriaTemplateId] = useState('')
const [createTotalTarget, setCreateTotalTarget] = useState(0)
const [activeTab, setActiveTab] = useState('edit');
const [allow_cross_component_registration, setAllowCrossComponentRegistration] = useState(10002);
const [allow_cross_component_registration_reason, setAllowCrossComponentRegistrationReason] = useState('');
const [isSavingCrossRegistration, setIsSavingCrossRegistration] = useState(false);
const [permissions, setPermissions] = useState(null);
const [users, setUsers] = useState(null);
const [selectedPermissions, setSelectedPermissions] = useState([]);
const [selectedUsers, setSelectedUsers] = useState([]);
const [showPermissionsModal, setShowPermissionsModal] = useState(false);
const [permissionsComponentName, setPermissionsComponentName] = useState("");

const getCreatedComponentId = (data) => {
  if (!data) return null;
  if (typeof data === "string") return data;
  if (Array.isArray(data)) {
    return getCreatedComponentId(data[0]);
  }
  return (
    data.id ||
    data.component_id ||
    data.assigned_component_id ||
    data.assigned_components_id ||
    data.components_id ||
    null
  );
};

const findComponentIdInList = (items, componentName) => {
  if (!Array.isArray(items) || !componentName) return null;
  const normalizedName = String(componentName).trim().toLowerCase();
  const matches = items.filter(
    (item) => String(item?.name || "").trim().toLowerCase() === normalizedName
  );
  if (matches.length === 0) return null;
  matches.sort(
    (a, b) => new Date(b?.created_at || 0).getTime() - new Date(a?.created_at || 0).getTime()
  );
  return getCreatedComponentId(matches[0]);
};

const togglePermissionsModal = () => {
  setShowPermissionsModal((prev) => !prev);
  if (showPermissionsModal) {
    setSelectedPermissions([]);
    setSelectedUsers([]);
    setPermissionsComponentName("");
  }
};

  useEffect(() => {
    listComponents();
    listComponentTypes();
    listExtraTemplates();
    listCriteriaTemplates();
    listUsers();
    return () => {};
  }, []);

  const listExtraTemplates = () => {
  genericGet("projects/list-extra-templates")
  .then((res) => {
    
    if (res.status == 200) {
      if (res.data.status == SUCCESS_RESULT) {
        setextra_templates(res.data["data"]);
     
      } else {
        cogoToast.error(res.data.message, {});
      }
    } else {
      cogoToast.error("Connection error. Please try again.", {});
    }
    setIsLoading(false);
  })
  .catch((err) => {
    // log("Error:: ");
    // log(err);
    setIsLoading(false);
    cogoToast.error("Critical error occurred. Please try again.", {});
  });
  }

  const listCriteriaTemplates = () => {
    genericGet("projects/list-selection-criteria-templates")
    .then((res) => {
      if (res.status == 200) {
        if (res.data.status == SUCCESS_RESULT) {
          setcriteria_templates(res.data["data"]);
        } else {
          cogoToast.error(res.data.message, {});
        }
      } else {
        cogoToast.error("Connection error. Please try again.", {});
      }
      setIsLoading(false);
    })
    .catch((err) => {
    setIsLoading(false);
    cogoToast.error("Critical error occurred. Please try again.", {});
  });
  }

  const buildComponentUpdatePayload = () => {
    const allowValue = Number(allow_cross_component_registration);
    return {
      project_id: project?.project_id,
      component_id,
      name,
      component_type_id,
      enrollment_startdate,
      enrollment_enddate,
      registration_bio_required,
      card_onboarding_required,
      status: status ?? 10001,
      total_target,
      extra_info_template_id,
      enrollment_template_id,
      criteria_template_id: criteria_template_id || null,
      allow_mobile_beneficiary_upload: !!allow_mobile_beneficiary_upload,
      allow_cross_component_registration: allowValue,
      allow_cross_component_registration_reason:
        allowValue === 10001 ? allow_cross_component_registration_reason.trim() : "",
    };
  };

  const handleUpdateCrossComponentRegistration = async (e) => {
    e.preventDefault();

    if (!component_id || !project?.project_id) {
      cogoToast.error("Component details are missing.");
      return;
    }

    if (!name || !component_type_id || !enrollment_startdate ||
        !enrollment_enddate || !enrollment_template_id) {
      cogoToast.error("Component details are incomplete. Please check the Edit Component tab.");
      return;
    }

    const allowValue = Number(allow_cross_component_registration);
    if (allowValue === 10001 && !allow_cross_component_registration_reason.trim()) {
      cogoToast.error("Please provide a reason when cross-component registration is allowed.");
      return;
    }

    const payload = buildComponentUpdatePayload();

    setIsSavingCrossRegistration(true);
    try {
      const response = await CreateComponents(payload);
      if (response.status === 200 && response.data.status === SUCCESS_RESULT) {
        cogoToast.success(response.data.message || "Cross-component registration settings updated.");
        listComponents();
      } else {
        cogoToast.error(response?.data?.message || "Failed to update cross-component registration settings.");
      }
    } catch (error) {
      cogoToast.error("Failed to update cross-component registration settings.");
    } finally {
      setIsSavingCrossRegistration(false);
    }
  };

  const getPermissions = (resourceId, componentName = "") => {
    if (!resourceId) return;
    setSelectedPermissions([]);
    setSelectedUsers([]);
    setPermissionsComponentName(componentName || "");
    setIsLoading(true);
    genericGet(`${ENDPOINTS.LIST_PERMISSIONS_TO_ASSIGN}?resource_id=${encodeURIComponent(resourceId)}`)
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT || res.data.status == DEFAULT_RESULT) {
            setPermissions(Array.isArray(res.data.data) ? res.data.data : []);
            setShowPermissionsModal(true);
          } else {
            cogoToast.error(res.data.message || "Failed to load permissions.", {});
          }
        } else {
          cogoToast.error("Failed to load permissions.", {});
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("Load permissions error", err);
        cogoToast.error("Failed to load permissions.", {});
      });
  };

  const handlePermissionPaste = (event) => {
    const pasteData = event.clipboardData.getData("text");
    const values = pasteData.split(",").map((val) => val.trim()).filter(Boolean);
    const newOptions = values.map((value) => ({ label: value, value: getUserIdFromPaste(value) }));
    setSelectedUsers((prev) => [...prev, ...newOptions]);
    event.preventDefault();
  };

  const getUserIdFromPaste = (value) => {
    let userId = null;
    (users || []).forEach((user) => {
      if (user.label.toLowerCase().includes(value.toLowerCase())) {
        userId = user.value;
      }
    });
    return userId;
  };

  const handlePermissionUserChange = (selected) => {
    setSelectedUsers(selected || []);
  };

  const listUsers = () => {
    genericGet(ENDPOINTS.LIST_ACTIVE_USERS)
      .then((res) => {
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            const usrs = JSON.parse(JSON.stringify(res.data.data).split('"text":').join('"label":'));
            setUsers(usrs);
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const assignAccessRights = () => {
    const data = [];
    selectedUsers.forEach((user) => {
      selectedPermissions.forEach((perm) => {
        data.push({
          user_id: user.value,
          module_permission_id: perm.value,
          status: 10001,
          is_updating: 1,
        });
      });
    });

    if (data.length === 0) {
      cogoToast.error("Please select at least one permission and one user.", {});
      return;
    }

    setIsLoading(true);
    genericPost(ENDPOINTS.UPDATE_ACCESS_PERMISSION, data)
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            setShowPermissionsModal(false);
            setSelectedPermissions([]);
            setSelectedUsers([]);
            cogoToast.success(res.data.message, {});
          } else {
            cogoToast.error(res.data.message, {});
            setShowPermissionsModal(false);
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        cogoToast.error("Failed to save permissions.", {});
      });
  };

  const listComponentTypes = () => {
 
    setIsLoading(true);

    getComponentTypes({ project_id: project?.project_id })
      .then((res) => {
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            setcomponent_types(res.data.data);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            cogoToast.error(res.data.message, {
              position: "top-right",
              hideProgressBar: false,
              closeOnClick: true,
              draggable: true,
            });
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        cogoToast.error("Something went wrong, please Try again. ", {
          position: "bottom-right",
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
        });
      });
  };
 

  const listComponents = () => {
    setIsLoading(true);

    return getComponents({ project_id: project?.project_id })
      .then((res) => {
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            const items = Array.isArray(res.data.data) ? res.data.data : [];
            setComponents(items);
            return items;
          }
          cogoToast.error(res.data.message, {
            position: "top-right",
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
          });
          return [];
        }
        return [];
      })
      .catch((err) => {
        cogoToast.error("Something went wrong, please Try again. ", {
          position: "bottom-right",
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
        });
        return [];
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const openPermissionsForCreatedComponent = (responseData, componentName) => {
    listComponents().then((items) => {
      const componentId =
        getCreatedComponentId(responseData) || findComponentIdInList(items, componentName);
      if (componentId) {
        getPermissions(componentId, componentName);
        return;
      }
      cogoToast.warn("Component created, but permissions setup could not be opened automatically.", {
        hideAfter: 5,
      });
    });
  };

  const createComponent = (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!createName || !createComponentTypeId || !createEnrollmentStartdate || 
        !createEnrollmentEnddate || !createEnrollmentTemplateId) {
      cogoToast.error("Please fill in all required fields", {});
      return;
    }

    let data = {
      "project_id": project?.project_id,
      "name": createName,
      "component_type_id": createComponentTypeId,
      "enrollment_startdate": createEnrollmentStartdate,
      "enrollment_enddate": createEnrollmentEnddate,
      "registration_bio_required": createRegistrationBioRequired,
      "card_onboarding_required": createCardOnboardingRequired,
      "status": 10001,
      "enrollment_template_id": createEnrollmentTemplateId,
      "extra_template_id": extra_info_template_id || null,
      "criteria_template_id": createCriteriaTemplateId || null,
      "total_target": createTotalTarget,
    };

setIsLoading(true);

CreateComponents(data)
      .then((res) => {
        setIsLoading(false);

        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            const createdName = createName;
            cogoToast.success("Component was created successfully", {});
            setcreateModal(false);
            // Reset form state
            setCreateName('');
            setCreateComponentTypeId('');
            setCreateEnrollmentStartdate('');
            setCreateEnrollmentEnddate('');
            setCreateRegistrationBioRequired(10001);
            setCreateCardOnboardingRequired(10001);
            setCreateEnrollmentTemplateId('');
            setCreateCriteriaTemplateId('');
            setCreateTotalTarget(0);
            openPermissionsForCreatedComponent(res.data?.data, createdName);
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        cogoToast.error("Something went wrong, please try again.", {});
      });
  }

const editComponent = (e) => {
  e.preventDefault();
  
  // Validate required fields
  if (!name || !component_type_id || !enrollment_startdate || 
      !enrollment_enddate || !enrollment_template_id) {
    cogoToast.error("Please fill in all required fields", {});
    return;
  }

  const data = buildComponentUpdatePayload();

setIsLoading(true);

CreateComponents(data)
    .then((res) => {
      setIsLoading(false);

      if (res.status == 200) {
        if (res.data.status == SUCCESS_RESULT) {
setEditModal(false);
          cogoToast.success(res.data.message || "Component updated successfully", {});
          listComponents();
        } else {
          cogoToast.error(res.data.message, {});
        }
      }
    })
    .catch((err) => {
      setIsLoading(false);
      console.log(err);
      cogoToast.error("Something went wrong, please try again.", {});
    });
}

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
      return;
    }
    setSortField(field);
    setSortDirection("asc");
  };

  const renderSortIcon = (field) => {
    if (sortField !== field) return <FaSort className="ms-1 opacity-50" size={11} />;
    return sortDirection === "asc" ? (
      <FaSortUp className="ms-1" size={11} />
    ) : (
      <FaSortDown className="ms-1" size={11} />
    );
  };

  const filteredSortedComponents = useMemo(() => {
    const query = componentSearch.trim().toLowerCase();
    let rows = Array.isArray(components) ? [...components] : [];
    if (query) {
      rows = rows.filter((row) => {
        const haystack = [
          row?.name,
          row?.created_at,
          row?.enrollment_startdate,
          row?.enrollment_enddate,
          isCardRequired(row) ? "yes" : "no",
          isMobileUploadAllowed(row) ? "enabled" : "disabled",
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();
        return haystack.includes(query);
      });
    }

    rows.sort((a, b) => {
      let aVal = a?.[sortField];
      let bVal = b?.[sortField];
      if (sortField === "card_onboarding_required") {
        aVal = isCardRequired(a) ? 1 : 0;
        bVal = isCardRequired(b) ? 1 : 0;
      } else if (sortField === "mobile_upload") {
        aVal = isMobileUploadAllowed(a) ? 1 : 0;
        bVal = isMobileUploadAllowed(b) ? 1 : 0;
      }
      if (aVal == null) aVal = "";
      if (bVal == null) bVal = "";
      if (typeof aVal === "string") aVal = aVal.toLowerCase();
      if (typeof bVal === "string") bVal = bVal.toLowerCase();
      if (aVal < bVal) return sortDirection === "asc" ? -1 : 1;
      if (aVal > bVal) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });
    return rows;
  }, [components, componentSearch, sortField, sortDirection]);

  const openEditComponent = (row) => {
    if (!row) return;
    setcomponent_id(row.id);
    setcomponent_type_id(row.component_type_id);
    setname(row.name);
    setregistration_bio_required(row.registration_bio_required);
    setcard_onboarding_required(row.card_onboarding_required);
    setenrollment_startdate(row.enrollment_startdate);
    setenrollment_enddate(row.enrollment_enddate);
    setstatus(row.status);
    setallow_mobile_beneficiary_upload(
      row.allow_mobile_beneficiary_upload === true ||
        row.allow_mobile_beneficiary_upload === 10001 ||
        row.allow_mobile_beneficiary_upload === "10001"
    );
    settotal_target(row.total_target !== undefined && row.total_target !== null ? row.total_target : 0);
    setEnrollment_template_id(row.enrollment_template_id || "");
    const selectionCriteriaId = row.selection_criteria_id || row.criteria_template_id || "";
    setcriteria_template_id(selectionCriteriaId);
    setextra_info_template_id(row.extra_info_template_id || null);
    setAllowCrossComponentRegistration(
      parseAllowCrossComponentRegistration(row.allow_cross_component_registration)
    );
    setAllowCrossComponentRegistrationReason(row.allow_cross_component_registration_reason || "");
    setActiveTab("edit");
    setEditModal(true);
  };

  const openComponentCycles = (row) => {
    if (!row) return;
    history.push({
      pathname: "/projects/cycles",
      state: { component: row },
    });
  };

  const promptDeleteComponent = (row) => {
    if (!row?.id) return;
    setComponentToDelete(row);
    setShowDeleteModal(true);
    setOpenActionMenu(null);
  };

  const closeDeleteModal = () => {
    if (isDeletingComponent) return;
    setShowDeleteModal(false);
    setComponentToDelete(null);
  };

  const deleteComponent = () => {
    if (!componentToDelete?.id || !project?.project_id) {
      cogoToast.error("Project or component information is missing.", {});
      return;
    }

    setIsDeletingComponent(true);
    genericPost(ENDPOINTS.DELETE_COMPONENT, {
      project_id: project.project_id,
      component_id: componentToDelete.id,
    })
      .then((res) => {
        setIsDeletingComponent(false);
        if (
          res?.status === 200 &&
          (res?.data?.status === SUCCESS_RESULT || res?.data?.status === DEFAULT_RESULT)
        ) {
          cogoToast.success(res?.data?.message || "Component deleted successfully.", {});
          setShowDeleteModal(false);
          setComponentToDelete(null);
          listComponents();
        } else {
          cogoToast.error(res?.data?.message || "Failed to delete component.", {});
        }
      })
      .catch((err) => {
        setIsDeletingComponent(false);
        console.error("Delete component error", err);
        cogoToast.error("Failed to delete component.", {});
      });
  };

  const tableHeaderBaseStyle = {
    fontSize: "0.7rem",
    fontWeight: 600,
    color: "#64748b",
    textTransform: "none",
    letterSpacing: "0.01em",
    padding: "0.45rem 0.5rem",
  };

  const sortableHeaderStyle = {
    ...tableHeaderBaseStyle,
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
  };

  return (
    <div>
      <h1>PROJECT COMPONENTS</h1>
      <Breadcrumb className="ms-1">
        <BreadcrumbItem>
          <Link to="/ebms"> EBMS </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link to="/projects"> PROJECTS </Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>
          COMPONENTS
        </BreadcrumbItem>
      </Breadcrumb>
<br/>
<button className="btn btn-primary" onClick={()=> {
  setcreateModal(true);

                                        //  history.push({
                                        //     pathname: "/projects/create-component",
                                        //     state:{project:project}
                                        //   });

                                    }	} >
  CREATE NEW COMPONENT 
  </button>
      <div className="d-flex justify-content-center my-1">
        {isLoading && <Spinner />}
      </div>

      <Card className="border-0 shadow-sm mt-3">
        <CardHeader
          className="py-2 px-3 d-flex flex-wrap align-items-center justify-content-between gap-2"
          style={{ background: "linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)" }}
        >
          <div style={{ fontWeight: 700, color: "#1e293b" }}>Project Components</div>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <Input
              type="search"
              bsSize="sm"
              placeholder="Search components..."
              value={componentSearch}
              onChange={(e) => setComponentSearch(e.target.value)}
              style={{ minWidth: 220, maxWidth: 320 }}
            />
            <Badge color="light" style={{ color: "#475569", border: "1px solid #e2e8f0" }}>
              {filteredSortedComponents.length} shown
            </Badge>
          </div>
        </CardHeader>
        <CardBody className="p-0">
          <div className="table-responsive">
            <Table
              hover
              striped
              size="sm"
              className="mb-0 align-middle"
              style={{ fontSize: "0.8125rem" }}
            >
              <thead style={{ backgroundColor: "#f1f5f9", position: "sticky", top: 0, zIndex: 1 }}>
                <tr style={{ verticalAlign: "middle" }}>
                  <th style={{ width: 48, ...tableHeaderBaseStyle }}>#</th>
                  <th style={sortableHeaderStyle} onClick={() => handleSort("name")}>
                    Component Name {renderSortIcon("name")}
                  </th>
                  <th style={sortableHeaderStyle} onClick={() => handleSort("created_at")}>
                    Created {renderSortIcon("created_at")}
                  </th>
                  <th style={sortableHeaderStyle} onClick={() => handleSort("enrollment_startdate")}>
                    Enrollment Start {renderSortIcon("enrollment_startdate")}
                  </th>
                  <th style={sortableHeaderStyle} onClick={() => handleSort("enrollment_enddate")}>
                    Enrollment End {renderSortIcon("enrollment_enddate")}
                  </th>
                  <th style={{ ...sortableHeaderStyle, width: 110 }} onClick={() => handleSort("mobile_upload")}>
                    Mobile Upload {renderSortIcon("mobile_upload")}
                  </th>
                  <th style={{ ...sortableHeaderStyle, width: 100 }} onClick={() => handleSort("card_onboarding_required")}>
                    Card Req. {renderSortIcon("card_onboarding_required")}
                  </th>
                  <th style={{ ...tableHeaderBaseStyle, width: 96, textAlign: "center" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredSortedComponents.length === 0 ? (
                  <tr>
                    <td colSpan={8} className="text-center text-muted py-4">
                      {isLoading ? "Loading components..." : "No components found."}
                    </td>
                  </tr>
                ) : (
                  filteredSortedComponents.map((row, index) => {
                    const mobileAllowed = isMobileUploadAllowed(row);
                    const endDateRaw = row?.enrollment_enddate;
                    const parsedEndDate = endDateRaw ? new Date(endDateRaw) : null;
                    const isEndDatePassed =
                      parsedEndDate instanceof Date &&
                      !Number.isNaN(parsedEndDate.getTime()) &&
                      parsedEndDate < new Date(new Date().setHours(0, 0, 0, 0));

                    return (
                      <tr key={row.id || index}>
                        <td className="text-muted">{index + 1}</td>
                        <td style={{ fontWeight: 600, color: "#0f172a" }}>{row.name || "—"}</td>
                        <td>{formatTableDate(row.created_at)}</td>
                        <td>{formatTableDate(row.enrollment_startdate)}</td>
                        <td>{formatTableDate(row.enrollment_enddate)}</td>
                        <td>
                          <div className="d-flex align-items-center gap-1">
                            <Input
                              type="checkbox"
                              checked={mobileAllowed}
                              readOnly
                              style={{ margin: 0, cursor: "default" }}
                              title={
                                isEndDatePassed
                                  ? "Disabled: Enrollment end date has passed"
                                  : mobileAllowed
                                  ? "Mobile beneficiary upload is enabled"
                                  : "Mobile beneficiary upload is disabled"
                              }
                            />
                            {!mobileAllowed && (
                              <FaExclamationTriangle
                                style={{ color: "#f59e0b", flexShrink: 0 }}
                                title={
                                  isEndDatePassed
                                    ? "Disabled: Enrollment end date has passed"
                                    : "Mobile beneficiary upload is disabled"
                                }
                              />
                            )}
                          </div>
                        </td>
                        <td>
                          {isCardRequired(row) ? (
                            <Badge color="success" pill style={{ fontSize: "0.72rem" }}>
                              Yes
                            </Badge>
                          ) : (
                            <Badge color="secondary" pill style={{ fontSize: "0.72rem" }}>
                              No
                            </Badge>
                          )}
                        </td>
                        <td className="text-center">
                          <Dropdown
                            isOpen={openActionMenu === row.id}
                            toggle={() =>
                              setOpenActionMenu(openActionMenu === row.id ? null : row.id)
                            }
                          >
                            <DropdownToggle
                              caret
                              color="light"
                              size="sm"
                              style={{
                                fontSize: "0.72rem",
                                padding: "0.2rem 0.45rem",
                                border: "1px solid #cbd5e1",
                                color: "#334155",
                              }}
                            >
                              Actions
                            </DropdownToggle>
                            <DropdownMenu end strategy="fixed" style={{ zIndex: 3000, fontSize: "0.8125rem" }}>
                              <DropdownItem
                                onClick={() => {
                                  openComponentCycles(row);
                                  setOpenActionMenu(null);
                                }}
                              >
                                <FaCalendarAlt className="me-2 text-success" />
                                Cycles
                              </DropdownItem>
                              <DropdownItem
                                onClick={() => {
                                  openEditComponent(row);
                                  setOpenActionMenu(null);
                                }}
                              >
                                <FaEdit className="me-2 text-primary" />
                                Edit
                              </DropdownItem>
                              <DropdownItem
                                divider
                              />
                              <DropdownItem
                                className="text-danger"
                                onClick={() => promptDeleteComponent(row)}
                              >
                                <FaTrash className="me-2" />
                                Delete
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

<Modal
        isOpen={createModal}
        toggle={toggle}
        backdrop={true}
className="modal-70w" 
       >
        <ModalHeader toggle={toggle} style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
          <div className="d-flex align-items-center">
            <FaPlus className="me-2" style={{ color: '#0d6efd' }} />
            <h5 className="mb-0" style={{ fontWeight: '600' }}>Create New Component</h5>
          </div>
         </ModalHeader>
        <ModalBody style={{ padding: '1rem' }}>
          <Form onSubmit={createComponent}>
            {/* Component Name - Full Width */}
            <Row className="mb-2">
              <Col md={12}>
                <FormGroup style={{ marginBottom: '0.75rem' }}>
                  <Label for="name" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                    Component Name <span style={{ color: 'red' }}>*</span>
                  </Label>
                  <Input
                    type="text"
                    name="name"
                    id="name"
                    value={createName}
                    onChange={(e) => setCreateName(e.target.value)}
                    required
                    placeholder="Enter component name"
                    style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                  />
                </FormGroup>
              </Col>
            </Row>

            {/* Three Column Layout */}
            <Row>
              <Col md={4}>
                <FormGroup style={{ marginBottom: '0.75rem' }}>
                  <Label for="component_type_id" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                    Component Type <span style={{ color: 'red' }}>*</span>
                  </Label>
                  <Input
                    type="select"
                    name="component_type_id"
                    id="component_type_id"
                    value={createComponentTypeId}
                    onChange={(e) => setCreateComponentTypeId(e.target.value)}
                    required
                    style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                  >
                    <option value="">Select Type</option>
                    {component_types?.map((p, i) => (
                      <option key={i} value={p.id}>{p.name}</option>
                    ))}
                  </Input>
                </FormGroup>

                <FormGroup style={{ marginBottom: '0.75rem' }}>
                  <Label for="enrollment_startdate" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                    Start Date <span style={{ color: 'red' }}>*</span>
                  </Label>
                  <Input
                    type="date"
                    name="enrollment_startdate"
                    id="enrollment_startdate"
                    value={createEnrollmentStartdate}
                    onChange={(e) => setCreateEnrollmentStartdate(e.target.value)}
                    required
                    style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                  />
                </FormGroup>

                <FormGroup style={{ marginBottom: '0.75rem' }}>
                  <Label for="registration_bio_required" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                    Biometric Required <span style={{ color: 'red' }}>*</span>
                  </Label>
                  <Input
                    type="select"
                    name="registration_bio_required"
                    id="registration_bio_required"
                    value={createRegistrationBioRequired}
                    onChange={(e) => setCreateRegistrationBioRequired(parseInt(e.target.value))}
                    required
                    style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                  >
                    <option value={10001}>Yes</option>
                    <option value={10002}>No</option>
                  </Input>
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup style={{ marginBottom: '0.75rem' }}>
                  <Label for="total_target" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                    Total Target <span style={{ color: 'red' }}>*</span>
                  </Label>
                  <Input
                    type="number"
                    name="total_target"
                    id="total_target"
                    value={createTotalTarget}
                    onChange={(e) => setCreateTotalTarget(e.target.value)}
                    required
                    placeholder="0"
                    min="0"
                    style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                  />
                </FormGroup>

                <FormGroup style={{ marginBottom: '0.75rem' }}>
                  <Label for="enrollment_enddate" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                    End Date <span style={{ color: 'red' }}>*</span>
                  </Label>
                  <Input
                    type="date"
                    name="enrollment_enddate"
                    id="enrollment_enddate"
                    value={createEnrollmentEnddate}
                    onChange={(e) => setCreateEnrollmentEnddate(e.target.value)}
                    required
                    style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                  />
                </FormGroup>

                <FormGroup style={{ marginBottom: '0.75rem' }}>
                  <Label for="card_onboarding_required" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                    Card Required <span style={{ color: 'red' }}>*</span>
                  </Label>
                  <Input
                    type="select"
                    name="card_onboarding_required"
                    id="card_onboarding_required"
                    value={createCardOnboardingRequired}
                    onChange={(e) => setCreateCardOnboardingRequired(parseInt(e.target.value))}
                    required
                    style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                  >
                    <option value={10001}>Yes</option>
                    <option value={10002}>No</option>
                  </Input>
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup style={{ marginBottom: '0.75rem' }}>
                  <Label for="enrollment_template_id" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                    Enrollment Template <span style={{ color: 'red' }}>*</span>
                  </Label>
                  <Input
                    type="select"
                    name="enrollment_template_id"
                    id="enrollment_template_id"
                    value={createEnrollmentTemplateId}
                    onChange={(e) => setCreateEnrollmentTemplateId(e.target.value)}
                    required
                    style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                  >
                    <option value="">Select Template</option>
            {extra_templates?.map((p, i) => {
                      if(p.type === "ENROLLMENT") {
                        return <option key={i} value={p.id}>{p.title}</option>;
                      }
                      return null;
                    })}
                  </Input>
                </FormGroup>

                <FormGroup style={{ marginBottom: '0.75rem' }}>
                  <Label for="criteria_template_id" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                    Criteria Template <span className="text-muted" style={{ fontSize: '0.8rem' }}>(Optional)</span>
                  </Label>
                  <Input
                    type="select"
                    name="criteria_template_id"
                    id="criteria_template_id"
                    value={createCriteriaTemplateId}
                    onChange={(e) => setCreateCriteriaTemplateId(e.target.value)}
                    style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                  >
                    <option value="">Select (Optional)</option>
                    {criteria_templates?.map((p, i) => (
                      <option key={i} value={p.id}>{p.title || p.name}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <ModalFooter style={{ borderTop: '1px solid #dee2e6', paddingTop: '0.75rem', marginTop: '0.5rem', paddingBottom: '0.75rem' }}>
              <Button
                color="secondary"
                onClick={toggle}
                style={{ borderRadius: '4px', padding: '0.4rem 1rem', fontSize: '0.9rem' }}
              >
                Cancel
              </Button>
              {!isLoading ? (
                <Button
                  type="submit"
                  color="primary"
                  style={{ borderRadius: '4px', padding: '0.4rem 1rem', fontWeight: '500', fontSize: '0.9rem' }}
                >
                  <FaPlus className="me-1" />
                  Create Component
                </Button>
              ) : (
                <Button
                  color="primary"
                  disabled
                  style={{ borderRadius: '4px', padding: '0.4rem 1rem', fontSize: '0.9rem' }}
                >
                  <Spinner size="sm" className="me-2" />
                  Processing...
                </Button>
              )}
            </ModalFooter>
          </Form>
        </ModalBody>
      </Modal>
     
     
      <Modal
        isOpen={editModal}
        toggle={Edittoggle}
           
        className="modal-70w"
      >
        <ModalHeader toggle={Edittoggle} style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
          <div className="d-flex align-items-center">
            <FaEdit className="me-2" style={{ color: '#0d6efd' }} />
            <h5 className="mb-0" style={{ fontWeight: '600' }}>Edit Component</h5>
          </div>
         </ModalHeader>

        <ModalBody style={{ padding: '1rem' }}>
          {/* Tab Navigation */}
          <ul className="nav nav-tabs mb-2" id="editComponentTabs" role="tablist" style={{ borderBottom: '2px solid #dee2e6' }}>
            <li className="nav-item" role="presentation">
              <button 
                className={`nav-link ${activeTab === 'edit' ? 'active' : ''}`}
                onClick={() => setActiveTab('edit')}
                type="button"
                role="tab"
                style={{
                  border: 'none',
                  borderBottom: activeTab === 'edit' ? '3px solid #0d6efd' : '3px solid transparent',
                  fontWeight: activeTab === 'edit' ? '600' : '400',
                  color: activeTab === 'edit' ? '#0d6efd' : '#6c757d',
                  padding: '0.5rem 1rem',
                  backgroundColor: 'transparent',
                  fontSize: '0.9rem'
                }}
              >
                <FaEdit className="me-1" />
                Edit Component
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === 'crossRegistration' ? 'active' : ''}`}
                onClick={() => setActiveTab('crossRegistration')}
                type="button"
                role="tab"
                style={{
                  border: 'none',
                  borderBottom: activeTab === 'crossRegistration' ? '3px solid #0d6efd' : '3px solid transparent',
                  fontWeight: activeTab === 'crossRegistration' ? '600' : '400',
                  color: activeTab === 'crossRegistration' ? '#0d6efd' : '#6c757d',
                  padding: '0.5rem 1rem',
                  backgroundColor: 'transparent',
                  fontSize: '0.9rem'
                }}
              >
                <FaExchangeAlt className="me-1" />
                Cross-Component Registration
              </button>
            </li>
          </ul>

          {/* Tab Content */}
          <div className="tab-content" id="editComponentTabContent">
            {/* Edit Component Tab */}
            <div className={`tab-pane fade ${activeTab === 'edit' ? 'show active' : ''}`} role="tabpanel">
              <Form onSubmit={editComponent}>
                {/* Component Name - Full Width */}
                <Row className="mb-2">
                  <Col md={12}>
                    <FormGroup style={{ marginBottom: '0.75rem' }}>
                      <Label for="edit_name" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                        Component Name <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input
                        type="text"
                        name="name"
                        id="edit_name"
                        value={name}
                        onChange={(e) => setname(e.target.value)}
                        required
                        placeholder="Enter component name"
                        style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {/* Three Column Layout */}
                <Row>
                  <Col md={4}>
                    <FormGroup style={{ marginBottom: '0.75rem' }}>
                      <Label for="edit_component_type_id" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                        Component Type <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input
                        type="select"
                        name="component_type_id"
                        id="edit_component_type_id"
                        value={component_type_id || ""}
                        onChange={(e) => setcomponent_type_id(e.target.value)}
                        required
                        style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                      >
                        <option value="">Select Type</option>
                        {component_types?.map((p, i) => (
                          <option key={i} value={p.id} selected={p.id === component_type_id}>
                            {p.name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup style={{ marginBottom: '0.75rem' }}>
                      <Label for="edit_enrollment_startdate" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                        Start Date <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input
                        type="date"
                        name="enrollment_startdate"
                        id="edit_enrollment_startdate"
                        value={enrollment_startdate}
                        onChange={(e) => setenrollment_startdate(e.target.value)}
                        required
                        style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                      />
                    </FormGroup>

                    <FormGroup style={{ marginBottom: '0.75rem' }}>
                      <Label for="edit_registration_bio_required" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                        Biometric Required <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input
                        type="select"
                        name="registration_bio_required"
                        id="edit_registration_bio_required"
                        value={registration_bio_required}
                        onChange={(e) => setregistration_bio_required(e.target.value)}
                        required
                        style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                      >
                        <option value={10001} selected={registration_bio_required == 10001}>Yes</option>
                        <option value={10002} selected={registration_bio_required == 10002}>No</option>
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col md={4}>
                    <FormGroup style={{ marginBottom: '0.75rem' }}>
                      <Label for="edit_total_target" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                        Total Target <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input
                        type="number"
                        name="total_target"
                        id="edit_total_target"
                        value={total_target}
                        onChange={(e) => settotal_target(e.target.value)}
                        required
                        placeholder="0"
                        min="0"
                        style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                      />
                    </FormGroup>

                    <FormGroup style={{ marginBottom: '0.75rem' }}>
                      <Label for="edit_enrollment_enddate" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                        End Date <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input
                        type="date"
                        name="enrollment_enddate"
                        id="edit_enrollment_enddate"
                        value={enrollment_enddate}
                        onChange={(e) => setenrollment_enddate(e.target.value)}
                        required
                        style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                      />
                    </FormGroup>

                    <FormGroup style={{ marginBottom: '0.75rem' }}>
                      <Label for="edit_card_onboarding_required" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                        Card Required <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input
                        type="select"
                        name="card_onboarding_required"
                        id="edit_card_onboarding_required"
                        value={card_onboarding_required}
                        onChange={(e) => setcard_onboarding_required(e.target.value)}
                        required
                        style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                      >
                        <option value={10001} selected={card_onboarding_required == 10001}>Yes</option>
                        <option value={10002} selected={card_onboarding_required == 10002}>No</option>
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col md={4}>
                    <FormGroup style={{ marginBottom: '0.75rem' }}>
                      <Label for="edit_enrollment_template_id" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                        Enrollment Template <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input
                        type="select"
                        name="enrollment_template_id"
                        id="edit_enrollment_template_id"
                        value={enrollment_template_id || ""}
                        onChange={(e) => setEnrollment_template_id(e.target.value)}
                        required
                        style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                      >
                        <option value="">Select Template</option>
                        {extra_templates?.map((p, i) => {
                          if(p.type === "ENROLLMENT") {
                            return (
                              <option key={i} value={p.id} selected={p.id === enrollment_template_id}>
                                {p.title}
                              </option>
                            );
                          }
                          return null;
                        })}
                      </Input>
                    </FormGroup>

                    <FormGroup style={{ marginBottom: '0.75rem' }}>
                      <Label for="edit_criteria_template_id" style={{ fontWeight: '500', marginBottom: '0.25rem', fontSize: '0.9rem' }}>
                        Criteria Template <span className="text-muted" style={{ fontSize: '0.8rem' }}>(Optional)</span>
                      </Label>
                      <Input
                        type="select"
                        name="criteria_template_id"
                        id="edit_criteria_template_id"
                        value={criteria_template_id || ""}
                        onChange={(e) => setcriteria_template_id(e.target.value)}
                        style={{ borderRadius: '4px', border: '1px solid #ced4da', fontSize: '0.9rem' }}
                      >
                        <option value="">Select (Optional)</option>
                        {criteria_templates?.map((p, i) => (
                          <option key={i} value={p.id} selected={p.id === criteria_template_id}>
                            {p.title || p.name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <FormGroup style={{ marginBottom: '0.75rem' }}>
                      <div
                        className="form-check"
                        style={{
                          padding: '0.65rem 0.75rem',
                          backgroundColor: '#f8f9fa',
                          borderRadius: '6px',
                          border: '1px solid #e9ecef',
                        }}
                      >
                        <Input
                          className="form-check-input"
                          type="checkbox"
                          id="edit_allow_mobile_beneficiary_upload"
                          checked={allow_mobile_beneficiary_upload}
                          onChange={(e) => setallow_mobile_beneficiary_upload(e.target.checked)}
                          style={{ marginTop: '0.3rem' }}
                        />
                        <Label
                          className="form-check-label"
                          htmlFor="edit_allow_mobile_beneficiary_upload"
                          style={{ fontWeight: '500', cursor: 'pointer' }}
                        >
                          Allow Mobile Beneficiary Upload
                        </Label>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>

                <ModalFooter style={{ borderTop: '1px solid #dee2e6', paddingTop: '0.75rem', marginTop: '0.5rem', paddingBottom: '0.75rem' }}>
                  <Button
                    color="secondary"
                    onClick={Edittoggle}
                    style={{ borderRadius: '4px', padding: '0.4rem 1rem', fontSize: '0.9rem' }}
                  >
                    Cancel
                  </Button>
                  {!isLoading ? (
                    <Button
                      type="submit"
                      color="primary"
                      style={{ borderRadius: '4px', padding: '0.4rem 1rem', fontWeight: '500', fontSize: '0.9rem' }}
                    >
                      <FaEdit className="me-1" />
                      Update Component
                    </Button>
                  ) : (
                    <Button
                      color="primary"
                      disabled
                      style={{ borderRadius: '4px', padding: '0.4rem 1rem', fontSize: '0.9rem' }}
                    >
                      <Spinner size="sm" className="me-2" />
                      Processing...
                    </Button>
                  )}
                </ModalFooter>
              </Form>
            </div>

            {/* Cross-Component Registration Tab */}
            <div className={`tab-pane fade ${activeTab === 'crossRegistration' ? 'show active' : ''}`} role="tabpanel">
              <Card style={{ border: 'none', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                <CardBody>
                  <div className="mb-4">
                    <h5 className="mb-2" style={{ color: '#495057', fontWeight: '600' }}>
                      <FaExchangeAlt className="me-2" style={{ color: '#0d6efd' }} />
                      Cross-Component Registration
                    </h5>
                    <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
                      Control whether beneficiaries can register on this component if they are already enrolled in another component. These settings are saved independently from the main component details.
                    </p>
                  </div>

                  <Form onSubmit={handleUpdateCrossComponentRegistration}>
                    <FormGroup>
                      <Label for="allow_cross_component_registration" style={{ fontWeight: '500', marginBottom: '0.5rem' }}>
                        Allow Cross-Component Registration <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input
                        type="select"
                        id="allow_cross_component_registration"
                        value={allow_cross_component_registration}
                        onChange={(e) => {
                          const nextValue = Number(e.target.value);
                          setAllowCrossComponentRegistration(nextValue);
                          if (nextValue !== 10001) {
                            setAllowCrossComponentRegistrationReason('');
                          }
                        }}
                        required
                        style={{ borderRadius: '6px', border: '1px solid #ced4da' }}
                      >
                        <option value={10001}>Allow</option>
                        <option value={10002}>Do not Allow</option>
                      </Input>
                      <small className="form-text text-muted">
                        Choose whether dual enrollment across project activities is permitted for this component.
                      </small>
                    </FormGroup>

                    {Number(allow_cross_component_registration) === 10001 && (
                      <FormGroup>
                        <Label for="allow_cross_component_registration_reason" style={{ fontWeight: '500', marginBottom: '0.5rem' }}>
                          Reason <span style={{ color: 'red' }}>*</span>
                        </Label>
                        <Input
                          type="textarea"
                          id="allow_cross_component_registration_reason"
                          rows={4}
                          value={allow_cross_component_registration_reason}
                          onChange={(e) => setAllowCrossComponentRegistrationReason(e.target.value)}
                          placeholder="e.g. Project allows dual enrollment across activities"
                          required
                          style={{ borderRadius: '6px', border: '1px solid #ced4da' }}
                        />
                        <small className="form-text text-muted">
                          Explain why cross-component registration is allowed for this component.
                        </small>
                      </FormGroup>
                    )}

                    <div className="d-flex justify-content-end gap-2 mt-4">
                      <Button
                        color="secondary"
                        type="button"
                        onClick={Edittoggle}
                        style={{ borderRadius: '6px', padding: '0.5rem 1.5rem' }}
                      >
                        Close
                      </Button>
                      {!isSavingCrossRegistration ? (
                        <Button
                          type="submit"
                          color="primary"
                          style={{ borderRadius: '6px', padding: '0.5rem 1.5rem', fontWeight: '500' }}
                        >
                          <FaCheckCircle className="me-1" />
                          Save Registration Settings
                        </Button>
                      ) : (
                        <Button
                          color="primary"
                          disabled
                          style={{ borderRadius: '6px', padding: '0.5rem 1.5rem' }}
                        >
                          <Spinner size="sm" className="me-2" />
                          Saving...
                        </Button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={showPermissionsModal} size="lg" backdrop toggle={togglePermissionsModal}>
        <ModalHeader toggle={togglePermissionsModal} style={{ padding: "0.75rem 1rem" }}>
          <div style={{ fontSize: "1.1rem", fontWeight: "600" }}>
            Assign Component Permissions
            {permissionsComponentName ? ` - ${permissionsComponentName}` : ""}
          </div>
        </ModalHeader>
        <ModalBody style={{ padding: "1rem" }}>
          <div style={{ fontSize: "0.9rem" }}>
            {permissions &&
              (() => {
                const allUsers = [];
                const userMap = new Map();

                permissions.forEach((perm) => {
                  if (perm.users && Array.isArray(perm.users)) {
                    perm.users.forEach((user) => {
                      if (user.email && !userMap.has(user.email)) {
                        userMap.set(user.email, user);
                        allUsers.push(user);
                      }
                    });
                  }
                });

                return allUsers.length > 0 ? (
                  <div className="card mb-2" style={{ border: "1px solid #dee2e6", borderRadius: "0.25rem" }}>
                    <div
                      className="card-header"
                      style={{
                        backgroundColor: "#f8f9fa",
                        fontWeight: "600",
                        padding: "0.5rem 0.75rem",
                        fontSize: "0.9rem",
                      }}
                    >
                      Current users with permissions
                    </div>
                    <div
                      className="card-body"
                      style={{ padding: "0.5rem 0.75rem", maxHeight: "150px", overflowY: "auto" }}
                    >
                      <div className="row" style={{ margin: "0" }}>
                        {allUsers.map((user, index) => (
                          <div
                            key={index}
                            className="col-md-6"
                            style={{ padding: "0.25rem 0.5rem", marginBottom: "0.25rem" }}
                          >
                            <div
                              style={{
                                padding: "4px 6px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "3px",
                                fontSize: "0.85rem",
                              }}
                            >
                              <div style={{ fontWeight: "600", fontSize: "0.85rem", lineHeight: "1.3" }}>
                                {user.name || "N/A"}
                              </div>
                              <div style={{ color: "#6c757d", fontSize: "0.75rem", lineHeight: "1.2" }}>
                                {user.email || "N/A"}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ) : null;
              })()}

            <h5 style={{ marginTop: "0.5rem", marginBottom: "0.5rem", fontSize: "1rem", fontWeight: "600" }}>
              Permissions
            </h5>
            {permissions && (
              <div style={{ marginBottom: "0.75rem" }}>
                <Select
                  closeMenuOnSelect={false}
                  components={animatedComponents}
                  isMulti
                  onChange={setSelectedPermissions}
                  options={permissions}
                  value={selectedPermissions}
                  styles={{
                    control: (base) => ({ ...base, minHeight: "32px", fontSize: "0.875rem" }),
                    menu: (base) => ({ ...base, fontSize: "0.875rem" }),
                    multiValue: (base) => ({ ...base, fontSize: "0.8rem" }),
                    multiValueLabel: (base) => ({ ...base, fontSize: "0.8rem", padding: "2px 6px" }),
                    multiValueRemove: (base) => ({ ...base, padding: "2px" }),
                  }}
                />
              </div>
            )}
            <hr style={{ margin: "0.75rem 0" }} />

            <div style={{ marginBottom: "0.75rem" }}>
              <CreatableSelect
                isMulti
                onChange={handlePermissionUserChange}
                options={users}
                value={selectedUsers}
                onPaste={handlePermissionPaste}
                placeholder="Paste comma-separated values..."
                styles={{
                  control: (base) => ({ ...base, minHeight: "32px", fontSize: "0.875rem" }),
                  menu: (base) => ({ ...base, fontSize: "0.875rem" }),
                  multiValue: (base) => ({ ...base, fontSize: "0.8rem" }),
                  multiValueLabel: (base) => ({ ...base, fontSize: "0.8rem", padding: "2px 6px" }),
                  multiValueRemove: (base) => ({ ...base, padding: "2px" }),
                }}
              />
            </div>

            <textarea
              onPaste={handlePermissionPaste}
              placeholder="Paste comma-separated values..."
              style={{
                width: "100%",
                height: "60px",
                fontSize: "0.875rem",
                padding: "0.5rem",
                marginBottom: "0.75rem",
              }}
            />

            <div style={{ fontSize: "0.85rem", marginBottom: "0.75rem", color: "#6c757d" }}>
              Selected users: {selectedUsers.length}
            </div>
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={assignAccessRights}
              disabled={isLoading}
              style={{ fontSize: "0.875rem", padding: "0.375rem 0.75rem" }}
            >
              Save Permissions
            </button>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={showDeleteModal} toggle={closeDeleteModal} centered>
        <ModalHeader toggle={closeDeleteModal}>Delete Component</ModalHeader>
        <ModalBody>
          Are you sure you want to delete{" "}
          <strong>{componentToDelete?.name || "this component"}</strong>?
          <div className="text-muted small mt-2">This action cannot be undone.</div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeDeleteModal} disabled={isDeletingComponent}>
            Cancel
          </Button>
          <Button color="danger" onClick={deleteComponent} disabled={isDeletingComponent}>
            {isDeletingComponent ? (
              <>
                <Spinner size="sm" className="me-2" />
                Deleting...
              </>
            ) : (
              "Delete Component"
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ProjectComponents;